"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AamiConfig", {
  enumerable: true,
  get: function get() {
    return _aami.AamiConfig;
  }
});
Object.defineProperty(exports, "AhmConfig", {
  enumerable: true,
  get: function get() {
    return _ahm.AhmConfig;
  }
});
Object.defineProperty(exports, "AustunityConfig", {
  enumerable: true,
  get: function get() {
    return _austunity.AustunityConfig;
  }
});
Object.defineProperty(exports, "BrandConfigPropTypes", {
  enumerable: true,
  get: function get() {
    return _brandConfigPropTypes.BrandConfigPropTypes;
  }
});
exports.BrandConfigs = void 0;
Object.defineProperty(exports, "BupaConfig", {
  enumerable: true,
  get: function get() {
    return _bupa.BupaConfig;
  }
});
Object.defineProperty(exports, "BwmConfig", {
  enumerable: true,
  get: function get() {
    return _bwm.BwmConfig;
  }
});
Object.defineProperty(exports, "CBAConfig", {
  enumerable: true,
  get: function get() {
    return _cba.CBAConfig;
  }
});
Object.defineProperty(exports, "GumtreeConfig", {
  enumerable: true,
  get: function get() {
    return _gumtree.GumtreeConfig;
  }
});
Object.defineProperty(exports, "MedibankConfig", {
  enumerable: true,
  get: function get() {
    return _medibank.MedibankConfig;
  }
});
Object.defineProperty(exports, "OrivetConfig", {
  enumerable: true,
  get: function get() {
    return _orivet.OrivetConfig;
  }
});
Object.defineProperty(exports, "PIAConfig", {
  enumerable: true,
  get: function get() {
    return _pia.PIAConfig;
  }
});
Object.defineProperty(exports, "PetbarnConfig", {
  enumerable: true,
  get: function get() {
    return _petbarnpica.PetbarnConfig;
  }
});
Object.defineProperty(exports, "PinscomConfig", {
  enumerable: true,
  get: function get() {
    return _pinscom.PinscomConfig;
  }
});
Object.defineProperty(exports, "PotikiConfig", {
  enumerable: true,
  get: function get() {
    return _potiki.PotikiConfig;
  }
});
Object.defineProperty(exports, "RactConfig", {
  enumerable: true,
  get: function get() {
    return _ract.RactConfig;
  }
});
var _react = _interopRequireDefault(require("react"));
var _bupa = require("./brands/bupa");
var _cba = require("./brands/cba");
var _medibank = require("./brands/medibank");
var _pia = require("./brands/pia");
var _petsure = require("./brands/petsure");
var _pinscom = require("./brands/pinscom");
var _potiki = require("./brands/pinscom/themes/potiki");
var _ahm = require("./brands/pinscom/themes/ahm");
var _bwm = require("./brands/bwm");
var _classic = require("./brands/classic");
var _hcf = require("./brands/hcf");
var _austunity = require("./brands/pinscom/themes/austunity");
var _aami = require("./brands/pinscom/themes/aami");
var _orivet = require("./brands/pinscom/themes/orivet");
var _gumtree = require("./brands/pinscom/themes/gumtree");
var _ract = require("./brands/pinscom/themes/ract");
var _petbarnpica = require("./brands/pinscom/themes/petbarnpica");
var _version = require("./defaults/glm/version3");
var _brandConfigPropTypes = require("./propTypes/brandConfigPropTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var BrandConfigs = exports.BrandConfigs = {
  "default": _classic.ClassicConfig,
  bupa: _bupa.BupaConfig,
  cba: _cba.CBAConfig,
  medibank: _medibank.MedibankConfig,
  petsure: _petsure.PetSureConfig,
  pia: _pia.PIAConfig,
  pica: _pinscom.PinscomConfig,
  pinscom: _pinscom.PinscomConfig,
  potiki: _potiki.PotikiConfig,
  ahm: _ahm.AhmConfig,
  bwm: _bwm.BwmConfig,
  hcf: _hcf.HcfConfig,
  austunity: _austunity.AustunityConfig,
  aami: _aami.AamiConfig,
  orivet: _orivet.OrivetConfig,
  gumtree: _gumtree.GumtreeConfig,
  ract: _ract.RactConfig,
  petbarnpica: _petbarnpica.PetbarnConfig,
  glm3: _version.DefaultGLM3Config
};